import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Instagram } from "lucide-react";
import { LINKS } from "@/data/content";

const open = (url) => window.open(url, "_blank", "noopener,noreferrer");

// size: "lg" | "md" | "sm"
const sizeMap = {
  lg: "px-8 py-4 text-base",
  md: "px-6 py-3 text-sm",
  sm: "px-5 py-2.5 text-xs",
};

export const WhatsAppButton = ({ size = "lg", label = "WhatsApp Now", testId = "whatsapp-button", className = "" }) => (
  <motion.button
    data-testid={testId}
    onClick={() => open(LINKS.whatsapp)}
    whileHover={{ scale: 1.04 }}
    whileTap={{ scale: 0.97 }}
    transition={{ type: "spring", stiffness: 400, damping: 22 }}
    className={`group inline-flex items-center justify-center gap-2.5 rounded-full bg-gold text-black font-semibold tracking-tight shadow-[0_0_40px_rgba(212,175,55,0.25)] hover:bg-gold-light ${sizeMap[size]} ${className}`}
  >
    <MessageCircle className="w-[1.15em] h-[1.15em]" strokeWidth={2.25} />
    <span>{label}</span>
  </motion.button>
);

export const InstagramButton = ({ size = "lg", label = "DM on Instagram", testId = "instagram-button", className = "" }) => (
  <motion.button
    data-testid={testId}
    onClick={() => open(LINKS.instagram)}
    whileHover={{ scale: 1.04 }}
    whileTap={{ scale: 0.97 }}
    transition={{ type: "spring", stiffness: 400, damping: 22 }}
    className={`group inline-flex items-center justify-center gap-2.5 rounded-full glass text-white font-medium tracking-tight hover:bg-white/10 hover:border-white/25 ${sizeMap[size]} ${className}`}
  >
    <Instagram className="w-[1.15em] h-[1.15em] text-gold" strokeWidth={2.25} />
    <span>{label}</span>
  </motion.button>
);

export const CTAPair = ({ size = "lg", waLabel, igLabel, prefix = "cta", className = "" }) => (
  <div className={`flex flex-col sm:flex-row items-stretch sm:items-center gap-4 ${className}`}>
    <WhatsAppButton size={size} label={waLabel} testId={`${prefix}-whatsapp-button`} />
    <InstagramButton size={size} label={igLabel} testId={`${prefix}-instagram-button`} />
  </div>
);
